// Hand the lattice converter's ORIGINAL-part preview URL across the
// Prompt → Editor navigation (#309). The signed `previewUrl` lives only in the
// prompt-side HomepageContext; it is NOT persisted on the message/conversation.
// So when Generate fires we stash it here keyed by the new conversation id, and
// the editor's generation overlay reads it to show the original part (+ a
// "Generating NASA Unitcell Lattice…" spinner) for the whole solve, then swaps
// to the finished lattice. Module-level, session-scoped: survives the route
// change (same JS session), lost on a hard refresh — acceptable, the solve is
// ~20s and a mid-solve refresh just falls back to the plain spinner.
// #315: the preview carries the original part's signed STL URL AND (for STEP
// uploads) its B-rep edge buffers, so the during-solve overlay can draw real
// topological edges on the original part.
export interface LatticePreview {
  url: string;
  edgesB64?: string;
  tangentEdgesB64?: string;
}

const store = new Map<string, LatticePreview>();

export function setLatticePreview(
  conversationId: string,
  preview: LatticePreview,
) {
  if (conversationId && preview.url) store.set(conversationId, preview);
}

export function getLatticePreview(
  conversationId: string,
): LatticePreview | undefined {
  return conversationId ? store.get(conversationId) : undefined;
}

export function clearLatticePreview(conversationId: string) {
  store.delete(conversationId);
}
